<form [formGroup]="changeResponsibleForm">
    <app-modal>
        <ng-container title> {{ 'FEATURES.USER.TITLES.MOVE_RESPONSIBLE' | translate }}</ng-container>
        <ng-container body>
            <p>
                {{
                    'FEATURES.USER.MOVE_NUMBER_OF_AGREEMENTS'
                        | translate
                            : {
                                  value: getNumberOfSelectedAgreements()
                              }
                }}
            </p>
            <app-form-section>
                <app-form-row *ngIf="moveAll()">
                    <app-form-group>
                        <label for="customerId">{{ 'GENERAL.FROM' | translate }}</label>
                        <app-dropdown [items]="users$ | async" formControlName="from" />
                        <app-validation-message
                            *ngIf="showPotentialValidationMessages"
                            [control]="f.from"
                            languageKey="GENERAL.FROM"
                        />
                    </app-form-group>
                </app-form-row>
                <app-form-row>
                    <app-form-group>
                        <label for="customerId">{{ 'GENERAL.TO' | translate }}</label>
                        <app-dropdown [items]="users$ | async" formControlName="to" />
                        <app-validation-message
                            *ngIf="showPotentialValidationMessages"
                            [control]="f.to"
                            languageKey="GENERAL.TO"
                        />
                    </app-form-group>
                </app-form-row>
                <app-form-row>
                    <app-form-group>
                        <p class="info-text">
                            {{ 'FEATURES.USER.MOVE_RESPONSIBLE_INFO' | translate }}
                        </p>
                    </app-form-group>
                </app-form-row>
                <!-- <app-form-row>
                    <app-form-group>
                        <app-checkbox
                            [text]="'FEATURES.USER.INCLUDE_RESPONSIBLES' | translate"
                            formControlName="includeResponsibles"
                            (ngModelChange)="includeResponsiblesChange($event)"
                        />
                    </app-form-group>
                </app-form-row>
                <app-form-row>
                    <app-form-group>
                        <app-checkbox
                            [text]="'FEATURES.USER.INCLUDE_READERS' | translate"
                            formControlName="includeReaders"
                            (ngModelChange)="includeReadersChange($event)"
                        />
                    </app-form-group>
                </app-form-row>
                <app-form-row>
                    <app-form-group>
                        <app-checkbox
                            [text]="'FEATURES.USER.INCLUDE_REMINDERS' | translate"
                            formControlName="includeReminders"
                            (ngModelChange)="includeRemindersChange($event)"
                        />
                    </app-form-group>
                </app-form-row> -->
            </app-form-section>
        </ng-container>

        <ng-container footer>
            <button type="button" class="secondary" (click)="closeModal()">
                {{ 'BUTTONS.CANCEL' | translate }}
            </button>
            <button type="submit" class="primary" (click)="save()" [class.loading]="loading" [disabled]="isDisabled()">
                {{ 'BUTTONS.CONFIRM' | translate }}
            </button>
        </ng-container>
    </app-modal>
</form>
